module.exports = __webpack_public_path__ + "img/penguin.d1a92372.png";